import * as angular from "angular";

const importSampleFileLink = 'https://firebasestorage.googleapis.com/v0/b/bringoz-prod-imgs/o/import-xls-temp%2Fimport-accounts.xlsx?alt=media&token=4fac9407-abd3-454f-a680-54dcb2ca7967';
const importAgentsSampleFileLink = 'https://firebasestorage.googleapis.com/v0/b/bringoz-prod-imgs/o/import-xls-temp%2FAgent%20Assignment%20Manger%20sample%20file.xlsx?alt=media&token=3c1de008-8a91-4f39-8d9c-fe24c0bee35d';


const ACCOUNT_AGENT_IMPORT_PERMISSIONS = ['accounts.preferred.import', 'accounts.preferred.create'];

const agentAssignmentImportTypes = [
  {
    id: 'preferred',
    label: 'Preferred Agents',
    entity: 'AccountPreferredAgent',
    importerPath: 'importers-account-preferred-agents',
    permissions: ACCOUNT_AGENT_IMPORT_PERMISSIONS
  },
  {
    id: 'restricted',
    label: 'Restricted Agents',
    entity: 'AccountRestrictedAgent',
    importerPath: 'importers-account-restricted-agents',
    permissions: ACCOUNT_AGENT_IMPORT_PERMISSIONS
  },
  {
    id: 'dedicated',
    label: 'Dedicated Agents',
    entity: 'AccountDedicatedAgent',
    importerPath: 'importers-account-dedicated-agents',
    permissions: ACCOUNT_AGENT_IMPORT_PERMISSIONS
  }
];


angular
  .module('bringoz.admin.accounts')
  .constant('accountsConstants', {
    importSampleFileLink: importSampleFileLink,
    importAgentsSampleFileLink: importAgentsSampleFileLink,
    agentAssignmentImportTypes: agentAssignmentImportTypes
  });
